import Config from "./config";
import axios from "axios";

export const userExistsByEmail = (email: string) => {
  const endpoint = `${Config.baseAPIEndpoint}/v1/users/by-email/${email}`;

  return axios.get(endpoint);
};
